import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { LoginGuard } from './guards/login.guard';
import { PendingSelectOperadorGuard } from './guards/pendind-select-operador.guard';

const routes: Routes = [
  {
    path: 'loading',
    loadChildren: () => import('./pages/loading/loading.module').then( m => m.LoadingPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'seleccion-operario',
    canActivate: [LoginGuard],
    loadChildren: () => import('./pages/seleccion-operario/seleccion-operario.module').then( m => m.SeleccionOperarioPageModule)
  },
  {
    path: '',
    loadChildren: () => import('./pages/pages.module').then( m => m.PagesPageModule),
    canLoad: [LoginGuard],
    canActivate: [LoginGuard, PendingSelectOperadorGuard]
  },
  { path: '', redirectTo: 'main/listado-obras', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, paramsInheritanceStrategy: 'always' }),
    TranslateModule
  ],
  exports: [
    RouterModule,
    TranslateModule
  ]
})
export class AppRoutingModule {}
